import React, {

    useContext,

    useState

}

from "react";

import {

    useHistory

}

from "react-router-dom";

import {

    FontAwesomeIcon

}

from "@fortawesome/react-fontawesome";

import {

    faTrash

}

from "@fortawesome/free-solid-svg-icons";

import {

    OMNISCAN_BLUE

}

from "../../constants/colors";

import {

    CHANGE_DOCUMENT_BASKET

}

from "../../constants/action-types";

import Header

from "../../components/Header";

import LeftMenu

from "../../components/LeftMenu";

import useSnippetSniffer

from "./hooks/useSnippetSniffer";

import SnippetSearchBar

from "./components/SnippetSearchBar";

import SnippetSearchResults

from "./components/SnippetSearchResults";

import SnippetInspectDrawer

from "./components/SnippetInspectDrawer";

import DocumentInspectionDrawer

from "./components/DocumentInspectionDrawer";

import {

    store

}

from "../../context/store.js";









//========================================================
// Snippet Search
//
// Main Document Builder search workspace.
//
// The Document Builder basket is held in global state so
// that it survives navigation between the search and
// document builder routes.
//
// For the initial implementation only content selected from
// the Dynamic Snippet Selection Drawer is added.
//========================================================
export default function SnippetSearch()

{

    //========================================================
    // Global State
    //========================================================
    const globalState =

        useContext(store);


    const basketItems =

        globalState?.state?.documentBasket ||

        [];





    //========================================================
    // Search
    //========================================================
    const {

        results,

        total,

        page,

        size,

        loading,

        error,

        search,

        nextPage,

        previousPage

    } = useSnippetSniffer();


    const history =

        useHistory();





    //========================================================
    // Selected Snippet
    //========================================================
    const [

        selectedSnippet,

        setSelectedSnippet

    ] = useState(null);





    //========================================================
    // Drawers
    //========================================================
    const [

        snippetDrawerVisible,

        setSnippetDrawerVisible

    ] = useState(false);


    const [

        documentDrawerVisible,

        setDocumentDrawerVisible

    ] = useState(false);





    //========================================================
    // Empty Basket Confirmation
    //========================================================
    const [

        emptyBasketConfirmationVisible,

        setEmptyBasketConfirmationVisible

    ] = useState(false);





    //========================================================
    // Create Basket ID
    //
    // basketId identifies this particular working basket
    // object.
    //
    // Source provenance remains independently identified by
    // documentSnippetId and documentSnippetSectionId.
    //========================================================
    const createBasketId = () =>

    {

        if (

            typeof crypto !== "undefined" &&

            typeof crypto.randomUUID === "function"

        )

        {

            return crypto.randomUUID();

        }


        //====================================================
        // Fallback
        //====================================================
        return (

            "basket-" +

            Date.now() +

            "-" +

            Math.random()

                .toString(36)

                .substring(

                    2,

                    10

                )

        );

    };





    //========================================================
    // Inspect Snippet
    //========================================================
    const inspectSnippet = (snippet) =>

    {

        setSelectedSnippet(

            snippet

        );


        setSnippetDrawerVisible(

            true

        );


        setDocumentDrawerVisible(

            true

        );

    };





    //========================================================
    // Close Snippet
    //========================================================
    const closeSnippetDrawer = () =>

    {

        setSnippetDrawerVisible(

            false

        );


        setDocumentDrawerVisible(

            false

        );

    };





    //========================================================
    // View Page
    //========================================================
    const viewSnippetPage = (snippet) =>

    {

        console.log(

            "View page",

            snippet.documentId,

            snippet.pageNumber

        );

    };





    //========================================================
    // Previous Snippets
    //========================================================
    const previousSnippets = () =>

    {

        console.log(

            "Previous snippets"

        );

    };





    //========================================================
    // Add Snippet
    //
    // Existing entry point retained for later.
    //
    // For this first Document Builder pass we deliberately
    // only populate the basket from the dynamic page-content
    // selector.
    //========================================================
    const addSnippetToBasket = (snippet) =>

    {

        console.log(

            "Add snippet to basket - not yet enabled",

            snippet

        );

    };





    //========================================================
    // Add Dynamic Sections To Basket
    //
    // Called by DocumentInspectionDrawer after the user has
    // selected one or more persisted page-content sections.
    //
    // The selected content is normalised into the canonical
    // Document Builder basket shape here.
    //========================================================
    const addDynamicSectionsToBasket = (snippetData) =>

    {

        console.log(

            "Add dynamic content to basket",

            snippetData

        );


        //====================================================
        // Selected Sections
        //====================================================
        const selectedSections =

            Array.isArray(

                snippetData?.sections

            )

                ?

                snippetData.sections

                :

                [];


        if (

            selectedSections.length === 0

        )

        {

            return;

        }





        //====================================================
        // Build Basket Items
        //====================================================
        const newItems =

            selectedSections.map(

                section =>

                {

                    //============================================
                    // Section Type
                    //============================================
                    const sectionType =

                        (

                            section?.sectionType ||

                            ""

                        )

                            .toUpperCase();





                    //============================================
                    // Image
                    //============================================
                    const image =

                        sectionType === "IMAGE" ||

                        section?.hasImage === true ||

                        (

                            section?.contentType &&

                            section.contentType

                                .toLowerCase()

                                .startsWith(

                                    "image/"

                                )

                        );





                    //============================================
                    // Basket Item
                    //============================================
                    return {

                        //========================================
                        // Basket Identity
                        //========================================
                        basketId:

                            createBasketId(),


                        //========================================
                        // Basket Content Type
                        //========================================
                        basketContentType:

                            image

                                ?

                                "IMAGE_SECTION"

                                :

                                "TEXT_SECTION",


                        //========================================
                        // Source Document
                        //========================================
                        documentId:

                            snippetData?.documentId ??

                            null,

                        documentSharepointId:

                            snippetData?.documentSharepointId ??

                            null,

                        documentTitle:

                            snippetData?.documentTitle ||

                            "Untitled Document",


                        //========================================
                        // Source Page
                        //========================================
                        documentSnippetId:

                            section?.documentSnippetId ??

                            snippetData?.documentSnippetId ??

                            null,

                        pageNumber:

                            section?.pageNumber ??

                            snippetData?.pageNumber ??

                            null,


                        //========================================
                        // Source Section
                        //========================================
                        documentSnippetSectionId:

                            section?.documentSnippetSectionId ??

                            section?.id ??

                            null,

                        sectionSequence:

                            section?.sequence ??

                            null,

                        sectionType:

                            section?.sectionType ??

                            null,


                        //========================================
                        // Content
                        //========================================
                        selectedText:

                            image

                                ?

                                null

                                :

                                (

                                    section?.selectedText ??

                                    section?.textContent ??

                                    null

                                ),

                        contentType:

                            section?.contentType ??

                            null,


                        //========================================
                        // Source Geometry
                        //========================================
                        x:

                            section?.x ??

                            null,

                        y:

                            section?.y ??

                            null,

                        width:

                            section?.width ??

                            null,

                        height:

                            section?.height ??

                            null,


                        //========================================
                        // Selection
                        //========================================
                        selectionType:

                            section?.selectionType ||

                            "PARTIAL",


                        //========================================
                        // Origin
                        //========================================
                        source:

                            "DYNAMIC_SECTION"

                    };

                }

            );





        //====================================================
        // Current Basket
        //====================================================
        const currentBasket =

            globalState?.state?.documentBasket ||

            [];





        //====================================================
        // Existing Source Section IDs
        //====================================================
        const existingSectionIds =

            new Set(

                currentBasket

                    .map(

                        item =>

                            item.documentSnippetSectionId

                    )

                    .filter(

                        sectionId =>

                            sectionId != null

                    )

            );





        //====================================================
        // Remove Duplicates
        //====================================================
        const uniqueNewItems =

            newItems.filter(

                item =>

                {

                    if (

                        item.documentSnippetSectionId == null

                    )

                    {

                        return true;

                    }


                    return !existingSectionIds.has(

                        item.documentSnippetSectionId

                    );

                }

            );





        //====================================================
        // Nothing New To Add
        //====================================================
        if (

            uniqueNewItems.length === 0

        )

        {

            return;

        }





        //====================================================
        // Updated Basket
        //====================================================
        const updatedBasket =

            [

                ...currentBasket,

                ...uniqueNewItems

            ];





        //====================================================
        // Update Global Basket
        //====================================================
        globalState.dispatch(

            {

                type:

                    CHANGE_DOCUMENT_BASKET,

                value:

                    updatedBasket

            }

        );

    };





    //========================================================
    // View Basket
    //========================================================
    const viewBasket = () =>

    {

        history.push(

            "/snippetdocumentbuilder"

        );

    };





    //========================================================
    // Request Empty Basket
    //========================================================
    const requestEmptyBasket = () =>

    {

        if (

            basketItems.length === 0

        )

        {

            return;

        }


        setEmptyBasketConfirmationVisible(

            true

        );

    };





    //========================================================
    // Cancel Empty Basket
    //========================================================
    const cancelEmptyBasket = () =>

    {

        setEmptyBasketConfirmationVisible(

            false

        );

    };





    //========================================================
    // Empty Basket
    //========================================================
    const emptyBasket = () =>

    {

        globalState.dispatch(

            {

                type:

                    CHANGE_DOCUMENT_BASKET,

                value:

                    []

            }

        );


        setEmptyBasketConfirmationVisible(

            false

        );

    };





    //========================================================
    // Render
    //========================================================
    return (

        <div style={styles.container}>

            <Header

                transitionHide={true}

            />


            <LeftMenu />


            <main style={styles.content}>


                {/*============================================
                    Heading
                ============================================*/}
                <div style={styles.headingRow}>

                    <div>

                        <div style={styles.heading}>

                            Document Builder

                        </div>


                        <div style={styles.description}>

                            Search across your property

                            documents and extracted content.

                        </div>

                    </div>





                    {/*========================================
                        Basket Controls
                    ========================================*/}
                    <div style={styles.basketControls}>


                        {/*====================================
                            View Basket
                        ====================================*/}
                        <button

                            type="button"

                            style={

                                {

                                    ...styles.basketButton,

                                    ...(basketItems.length === 0

                                        ?

                                        styles.basketButtonEmpty

                                        :

                                        {})

                                }

                            }

                            onClick={

                                viewBasket

                            }

                            disabled={

                                basketItems.length === 0

                            }

                        >

                            <span>

                                View Basket

                            </span>


                            <span style={styles.basketCount}>

                                {basketItems.length}

                            </span>

                        </button>





                        {/*====================================
                            Empty Basket
                        ====================================*/}
                        <button

                            type="button"

                            style={

                                {

                                    ...styles.emptyBasketButton,

                                    ...(basketItems.length === 0

                                        ?

                                        styles.emptyBasketButtonDisabled

                                        :

                                        {})

                                }

                            }

                            onClick={

                                requestEmptyBasket

                            }

                            disabled={

                                basketItems.length === 0

                            }

                            title="Empty basket"

                        >

                            <FontAwesomeIcon

                                icon={faTrash}

                            />

                        </button>

                    </div>

                </div>





                {/*============================================
                    Search
                ============================================*/}
                <SnippetSearchBar

                    onSearch={search}

                    loading={loading}

                />


                {

                    error &&

                    (

                        <div style={styles.error}>

                            {error}

                        </div>

                    )

                }





                {/*============================================
                    Search Results
                ============================================*/}
                <SnippetSearchResults

                    results={results}

                    total={total}

                    page={page}

                    size={size}

                    loading={loading}

                    onInspect={inspectSnippet}

                    onNext={nextPage}

                    onPrevious={previousPage}

                />





                {/*============================================
                    Snippet Inspection Drawer
                ============================================*/}
                <SnippetInspectDrawer

                    visible={snippetDrawerVisible}

                    snippet={selectedSnippet}

                    onClose={closeSnippetDrawer}

                    onViewPage={viewSnippetPage}

                    onPreviousSnippets={previousSnippets}

                    onAddSnippet={addSnippetToBasket}

                />





                {/*============================================
                    Document Inspection Drawer
                ============================================*/}
                <DocumentInspectionDrawer

                    visible={documentDrawerVisible}

                    documentId={

                        selectedSnippet?.documentId

                    }

                    documentSharepointId={

                        selectedSnippet?.documentSharepointId

                    }

                    documentUrl={

                        selectedSnippet?.documentUrl

                    }

                    documentTitle={

                        selectedSnippet?.documentTitle ||

                        "Untitled Document"

                    }

                    pageNumber={

                        selectedSnippet?.pageNumber ||

                        1

                    }

                    totalPages={1}

                    onViewSnippets={

                        addDynamicSectionsToBasket

                    }

                />

            </main>





            {/*============================================
                Empty Basket Confirmation
            ============================================*/}
            {

                emptyBasketConfirmationVisible &&

                (

                    <div style={styles.confirmBackdrop}>

                        <div style={styles.confirmDialog}>


                            {/*================================
                                Icon
                            ================================*/}
                            <div style={styles.confirmIcon}>

                                <FontAwesomeIcon

                                    icon={faTrash}

                                />

                            </div>





                            {/*================================
                                Title
                            ================================*/}
                            <div style={styles.confirmTitle}>

                                Empty Document Basket?

                            </div>





                            {/*================================
                                Message
                            ================================*/}
                            <div style={styles.confirmMessage}>

                                This will remove all{" "}

                                <strong>

                                    {basketItems.length}

                                </strong>

                                {" "}items from your Document Basket.

                                <br />

                                This action cannot be undone.

                            </div>





                            {/*================================
                                Actions
                            ================================*/}
                            <div style={styles.confirmActions}>

                                <button

                                    type="button"

                                    style={styles.confirmCancelButton}

                                    onClick={

                                        cancelEmptyBasket

                                    }

                                >

                                    Cancel

                                </button>


                                <button

                                    type="button"

                                    style={styles.confirmDeleteButton}

                                    onClick={

                                        emptyBasket

                                    }

                                >

                                    <FontAwesomeIcon

                                        icon={faTrash}

                                    />


                                    <span>

                                        Empty Basket

                                    </span>

                                </button>

                            </div>

                        </div>

                    </div>

                )

            }

        </div>

    );

}









//========================================================
// Styles
//========================================================
const styles =

{

    //========================================================
    // Container
    //========================================================
    container:

    {

        display:

            "flex",

        width:

            "100%",

        marginLeft:

            "50px",

        minHeight:

            "100vh",

        position:

            "relative",

        zIndex:

            1,

        background:

            "#f4f7f9"

    },



    //========================================================
    // Content
    //========================================================
    content:

    {

        width:

            "100%",

        height:

            "100vh",

        padding:

            "40px 40px 40px 40px",

        boxSizing:

            "border-box",

        overflowY:

            "auto",

        overflowX:

            "hidden"

    },



    //========================================================
    // Heading Row
    //========================================================
    headingRow:

    {

        width:

            "100%",

        display:

            "flex",

        alignItems:

            "flex-start",

        justifyContent:

            "space-between",

        gap:

            24,

        marginBottom:

            24

    },



    //========================================================
    // Heading
    //========================================================
    heading:

    {

        fontSize:

            "26px",

        fontWeight:

            600,

        color:

            "#263746",

        marginBottom:

            "6px"

    },

    description:

    {

        fontSize:

            "14px",

        color:

            "#73808b"

    },



    //========================================================
    // Basket Controls
    //========================================================
    basketControls:

    {

        display:

            "flex",

        alignItems:

            "center",

        gap:

            6

    },



    //========================================================
    // Basket Button
    //========================================================
    basketButton:

    {

        height:

            42,

        minWidth:

            132,

        padding:

            "0 10px 0 16px",

        display:

            "flex",

        alignItems:

            "center",

        justifyContent:

            "center",

        gap:

            10,

        border:

            "none",

        borderRadius:

            6,

        background:

            OMNISCAN_BLUE,

        color:

            "#ffffff",

        fontSize:

            12,

        fontWeight:

            600,

        cursor:

            "pointer",

        boxShadow:

            "0 4px 12px rgba(32,175,232,0.18)",

        transition:

            "opacity 160ms ease, box-shadow 160ms ease"

    },

    basketButtonEmpty:

    {

        opacity:

            0.38,

        cursor:

            "default",

        boxShadow:

            "none"

    },

    basketCount:

    {

        minWidth:

            24,

        height:

            24,

        padding:

            "0 6px",

        display:

            "inline-flex",

        alignItems:

            "center",

        justifyContent:

            "center",

        boxSizing:

            "border-box",

        borderRadius:

            4,

        background:

            "rgba(255,255,255,0.20)",

        color:

            "#ffffff",

        fontSize:

            11,

        fontWeight:

            700

    },



    //========================================================
    // Empty Basket Button
    //========================================================
    emptyBasketButton:

    {

        width:

            42,

        height:

            42,

        padding:

            0,

        display:

            "flex",

        alignItems:

            "center",

        justifyContent:

            "center",

        border:

            "none",

        borderRadius:

            6,

        background:

            OMNISCAN_BLUE,

        color:

            "#ffffff",

        fontSize:

            13,

        cursor:

            "pointer",

        boxShadow:

            "0 4px 12px rgba(32,175,232,0.18)",

        transition:

            "opacity 160ms ease, box-shadow 160ms ease"

    },

    emptyBasketButtonDisabled:

    {

        opacity:

            0.38,

        cursor:

            "default",

        boxShadow:

            "none"

    },



    //========================================================
    // Confirmation
    //========================================================
    confirmBackdrop:

    {

        position:

            "fixed",

        top:

            0,

        right:

            0,

        bottom:

            0,

        left:

            0,

        display:

            "flex",

        alignItems:

            "center",

        justifyContent:

            "center",

        background:

            "rgba(7,18,26,0.42)",

        backdropFilter:

            "blur(1px)",

        zIndex:

            20000

    },

    confirmDialog:

    {

        width:

            390,

        padding:

            "30px",

        boxSizing:

            "border-box",

        border:

            "1px solid rgba(38,55,70,0.10)",

        borderRadius:

            7,

        background:

            "#ffffff",

        boxShadow:

            "0 20px 60px rgba(20,35,50,0.22)",

        textAlign:

            "center"

    },

    confirmIcon:

    {

        width:

            42,

        height:

            42,

        margin:

            "0 auto 16px auto",

        display:

            "flex",

        alignItems:

            "center",

        justifyContent:

            "center",

        borderRadius:

            6,

        background:

            "rgba(180,67,67,0.08)",

        color:

            "#b44343",

        fontSize:

            15

    },

    confirmTitle:

    {

        marginBottom:

            10,

        color:

            "#263746",

        fontSize:

            17,

        fontWeight:

            600

    },

    confirmMessage:

    {

        marginBottom:

            24,

        color:

            "#73808b",

        fontSize:

            11,

        lineHeight:

            1.7

    },

    confirmActions:

    {

        display:

            "flex",

        justifyContent:

            "center",

        gap:

            8

    },

    confirmCancelButton:

    {

        height:

            38,

        padding:

            "0 18px",

        border:

            "1px solid rgba(38,55,70,0.14)",

        borderRadius:

            5,

        background:

            "#f4f7f9",

        color:

            "#52636f",

        fontSize:

            10,

        fontWeight:

            600,

        cursor:

            "pointer"

    },

    confirmDeleteButton:

    {

        height:

            38,

        padding:

            "0 18px",

        display:

            "flex",

        alignItems:

            "center",

        gap:

            8,

        border:

            "1px solid #b44343",

        borderRadius:

            5,

        background:

            "#b44343",

        color:

            "#ffffff",

        fontSize:

            10,

        fontWeight:

            600,

        cursor:

            "pointer",

        boxShadow:

            "0 4px 12px rgba(180,67,67,0.16)"

    },



    //========================================================
    // Error
    //========================================================
    error:

    {

        marginTop:

            "20px",

        fontSize:

            "13px",

        color:

            "#a94442"

    }

};